import React from 'react';
import logoImage from '../assets/logoSPT.jpg';

export default function Logo() {
  return (
    <img 
      src={logoImage} 
      alt="Logo SPT" 
      style={{ 
        height: '80px', // Altura estándar para un Navbar
        width: 'auto', 
        borderRadius: '8px', // Opcional: si quieres bordes redondeados
        objectFit: 'contain' 
      }} 
    />
  );
}
